import { RootState } from "../../app/state";
import { savedSearchAdapter } from "./searchState";
import { createSelector } from "@reduxjs/toolkit";

const selectRoot = (state: RootState) => state;

export const selectSearchSlice = (state: RootState) => state.savedSearch;

const adapterSelectors = savedSearchAdapter.getSelectors(selectSearchSlice);

export const selectAllSavedSearchList = adapterSelectors.selectAll;
export const selectSavedSearchById = adapterSelectors.selectById;

export const selectCurrentSavedSearchId = createSelector(
  selectSearchSlice,
  (slice) => slice.selectedSavedSearchId
);

export const selectCurrentSavedSearch = createSelector(
  selectRoot,
  selectCurrentSavedSearchId,
  (root, currentSearchId) => currentSearchId ? selectSavedSearchById(root, currentSearchId) : null
);

export const selectPublicSearchList = createSelector(
  selectAllSavedSearchList,
  (searchList) => searchList.filter((search) => !search.userId)
);

export const selectPrivateSearchList = createSelector(
  selectAllSavedSearchList,
  (searchList) => searchList.filter((search) => !!search.userId)
);

export const hasSavedSearch = createSelector(
  selectAllSavedSearchList,
  (list) => list.length > 0
);